import {
    ThemeProvider,
    createTheme,
    CssBaseline,
    Box,
    Drawer,
    AppBar,
    Toolbar,
    Typography,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    IconButton,
    Grid,
    Paper,
    TextField,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    LinearProgress,
    Avatar,
    Menu,
    MenuItem,
    useTheme,
} from "@mui/material";
import {
    Edit as EditIcon,
    Delete as DeleteIcon,
    Add as AddIcon,
  } from '@mui/icons-material';
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";
import MoreVertIcon from '@mui/icons-material/MoreVert';

import FlexBetween from "components/FlexBetween";

import { useGetEmployeesQuery, useGetAllClockingsQuery, useGetAllBreaksQuery, useDeleteEmployeeMutation, useResetEmployeePinMutation, useUpdateEmployeeMutation, useCreateEmployeeMutation } from "../../state/api";

const Skills = () => {
    const theme = useTheme();
    const isMobileScreen = useMediaQuery('(max-width:768px)'); 

    const skills = [
    { name: 'Python', value: 75 },
    { name: 'Java', value: 70 },
    { name: 'Git', value: 95 },
    { name: 'Postman', value: 45 },
    { name: 'Jupyter Notebook', value: 80 },
    { name: 'JavaScript', value: 85 },
    { name: 'HTML & CSS', value: 80 },
  ];
  return (
    <Box>
        <Paper sx={{ p: 2, borderRadius: '0.75rem' }}>
            <FlexBetween mb={2}>
                <Typography variant="h4">Manage Skills</Typography>
                <Button variant="contained" startIcon={<AddIcon />}>Add New Skill</Button>
            </FlexBetween>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Skill Name</TableCell>
                            <TableCell>Proficiency</TableCell>
                            <TableCell align="right">Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {skills.map(skill => (
                            <TableRow key={skill.name}>
                                <TableCell>{skill.name}</TableCell>
                                <TableCell>
                                <FlexBetween>
                                    <Box sx={{ width: '80%', mr: 1 }}>
                                        <LinearProgress variant="determinate" value={skill.value} sx={{ height: 8, borderRadius: 5 }} />
                                    </Box>
                                    <Typography variant="body2" color="text.secondary">{`${skill.value}%`}</Typography>
                                </FlexBetween>
                                </TableCell>
                                <TableCell align="right">
                                    <IconButton size="small"><EditIcon /></IconButton>
                                    <IconButton size="small"><DeleteIcon /></IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    </Box>
    )

}

export default Skills;

